import React from "react";
import Buttons from "../components/Buttons";
import Mouse from "../components/Mouse";
import Navigation from "../components/Navigation";
import Project from "../components/Project";

const Project2 = () => {
  return (
    <div>
      <main>
        <Mouse />
        <div className="project">
          <Navigation />
          <Project projectNumber={1} />
          <Buttons left={"/projet-1"} right={"/projet-3"} />
        </div>
      </main>
    </div>
  );
};

export default Project2;
